import React, { useState } from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"

import '../styles/global.css'

const Menu = () => (
  <nav>
    <ul className="flex flex-col space-y-3 text-gray-600 mb-12 md:mb-0">
      <li>
        <Link to="/vita" activeClassName="text-gray-900">Vita</Link>
      </li>
      <li>
        <Link to="/ausstellungen" activeClassName="text-gray-900">Ausstellungen</Link>
      </li>
      <li>
        <Link to="/galerie-skulpturen" activeClassName="text-gray-900">Galerie Skulpturen</Link>
      </li>
      <li>
        <Link to="/galerie-elfengondeln" activeClassName="text-gray-900">Galerie Elfengondeln</Link>
      </li>
      <li>
        <Link to="/kontakt" activeClassName="text-gray-900">Kontakt</Link>
      </li>
    </ul>
  </nav>
)

const Footer = () => (
  <nav className="flex space-x-5 mt-20 pt-4 text-sm border-t border-gray-200">
    <div>© {new Date().getFullYear()} Gesina Seldte</div>
    <ul className="mb-3 flex space-x-4">
      <li>
        <Link to="/impressum">Impressum</Link>
      </li>
      <li>
        <Link to="/datenschutzerklaerung">Datenschutz</Link>
      </li>
    </ul>
  </nav>
)

const PageTitle = () => {
  const { pathname } = useLocation()
  const [title, setTitle] = useState('')
  const onHelmetChange = ({ title }) => {
    let newTitle = title.replace(' – Gesina Seldte', '')

    if (pathname === '/ausstellungen') {
      newTitle = 'Bilder'
    }

    setTitle(newTitle)
  }

  return (
    <>
      {title && <h1 className="text-4xl border-b-2 border-gray-300">{title}</h1>}
      <Helmet onChangeClientState={onHelmetChange} />
    </>
  )
}

export default function Layout({ children }) {
  return (
    <>
      <div className={`flex flex-col min-h-screen p-10 font-sans`}>
        <div className="flex items-center mb-12">
          <div className="w-60 flex-shrink-0 text-3xl font-serif">
            <Link to="/">Gesina<br />Seldte</Link>
          </div>
          <PageTitle />
        </div>

        <div className="flex flex-col lg:flex-row flex-grow overflow-x-hidden">
          <div className="w-60 flex-shrink-0"><Menu /></div>
          <div className="flex flex-col flex-grow justify-between max-w-full overflow-x-hidden">
            {children}
            <Footer />
          </div>
        </div>
      </div>
    </>
  )
}
